import { Component, Prop, h } from '@stencil/core';

import dynamicEntryActions from '../../../actions/actions.dynamic-entry';
import { SelectOption } from '../../../interfaces/interface.banner';
import { dynamicEntryShiftDigitalTradeInVehicleIndicated } from '../../../tracking/tracking.dynamic-entry';
import { MAX_MILEAGE_INPUT_LENGTH, MSM_MILEAGE_ERRORS, formatMileage } from '../../../utils/utils.dynamic-entry';
import { parseMileage } from '../../../utils/utils.interactive-banner';
import { DynamicEntryWorkflow } from '../../../utils/utils.landing';
import { DynamicEntryStartButton } from '../DynamicEntryStartButton';

@Component({
  tag: 'dynamic-entry-model-style-mileage',
  styleUrl: 'dynamic-entry-model-style-mileage.css',
})
export class DynamicEntryModelStyleMileage {
  @Prop() dynamicEntryWorkflow: DynamicEntryWorkflow = DynamicEntryWorkflow.Unassigned;
  @Prop() model: string = '';
  @Prop() trim: string = '';
  @Prop() vin: string = '';
  @Prop() mileage: number = 0;
  @Prop() trimId: number = 0;
  @Prop() vehiclePossibilities: SelectOption[] = [];
  @Prop() yearId: number = 0;
  @Prop() make: string = '';
  @Prop() showStyle: boolean = false;
  @Prop() hasStyleError: boolean = false;
  @Prop() hasMileageError: boolean = false;
  @Prop() errorMessage: string = '';
  @Prop() dealerId: string = '';
  @Prop() changeVehicle: Function = () => {};
  @Prop() shouldShowIneligibleButton: boolean = true;
  @Prop() isFetching: boolean = false;
  @Prop() whenClickNext = () => {};

  onStyleChanged(event) {
    const trimId = parseInt(event.detail);
    dynamicEntryActions.onStyleChanged(trimId);
  }

  onMileageChanged(event) {
    const mileage = parseInt(event.detail);
    dynamicEntryActions.onMileageChanged(mileage);
  }

  hasError() {
    return this.hasStyleError || this.hasMileageError;
  }

  showError() {
    return this.hasStyleError || this.hasMileageError || !!this.errorMessage;
  }

  drHasError() {
    return this.dynamicEntryWorkflow === DynamicEntryWorkflow.DigitalRetail && this.shouldShowIneligibleButton && this.errorMessage === MSM_MILEAGE_ERRORS.MSM_INVALID_MILEAGE;
  }

  async onNextClicked() {
    const isMileageValid = await dynamicEntryActions.onValidateMileageRange();
    if (this.hasError() || !isMileageValid) {
      return;
    }

    if (dynamicEntryActions.onDuplicateOfferModalReopen()) {
      return;
    }

    dynamicEntryShiftDigitalTradeInVehicleIndicated();
    await dynamicEntryActions.onMileageSubmit();
    this.whenClickNext();
  }

  onProceedWithoutICOClick() {
    dynamicEntryActions.onProceedWithoutICO(this.hasMileageError, this.hasStyleError);
  }

  render() {
    return (
      <div class="dynamic-entry-model-style-mileage-base-font my-auto">
        <div class="flex flex-col mt-1 mb-2">
          <div class="flex mb-1 flex-col">
            <div class="flex space-x-3">
              {this.showStyle && (
                <input-select-secondary
                  testId="trim"
                  label="Style"
                  options={this.vehiclePossibilities}
                  onValueChange={(e) => this.onStyleChanged(e)}
                  hasError={this.hasStyleError}
                  class="flex-[1]"
                  value={this.trimId ? this.trimId.toString() : ''}
                />
              )}
              <input-text-box
                testId="mileage"
                onValueChange={(evt) => this.onMileageChanged(evt)}
                label="Mileage"
                maxLength={MAX_MILEAGE_INPUT_LENGTH}
                parse={parseMileage}
                format={formatMileage}
                hasError={this.hasMileageError}
                class="flex-[1]"
                value={this.mileage ? this.mileage.toString() : ''}
              />
            </div>
            <dynamic-entry-error hasError={this.showError()} errorMessage={this.errorMessage} hiddenMode={true} class="pt-1 w-full"></dynamic-entry-error>
            {this.drHasError() ? (
              <DynamicEntryStartButton class="w-full mt-3" label="Proceed without Instant Cash Offer" whenClicked={() => this.onProceedWithoutICOClick()} color="tertiary" />
            ) : (
              <DynamicEntryStartButton
                data-testid="bi-btn-get-started"
                class="w-full mt-3"
                label="Next"
                whenClicked={() => this.onNextClicked()}
                isFetching={this.isFetching}
                color="primary"
                disabled={this.hasError()}
              />
            )}
          </div>
        </div>
        <div class="flex gap-x-2 justify-center mt-3">
          <ico-hyperlink
            data-testid="bi-btn-change-vehicle"
            content="primary"
            href=""
            onClick={(e) => {
              e.preventDefault();
              this.changeVehicle();
            }}>
            Change Vehicle
          </ico-hyperlink>
        </div>
      </div>
    );
  }
}
